window.addEventListener("load", function() {
  const followingCheckbox = document.querySelector("#id_following");
  if (!followingCheckbox) return;
  followingCheckbox.addEventListener("change", function() {
    fetch(window.location.href + "follow/");
  });
});
